const THUMBNAIL_SHIFT = 0.45;
const CSS_INPUT_VARIABLE = "--percent-position-at-range";
const SUBSCRIPTION_RANGE_INPUT_ID = "subscriptionPrice";
const SUBSCRIPTION_PICKER_SHIFT = 2;
const FOLLOWER_PICKER_SHIFT = 8;

const $followerInput = document.querySelector("#followers");
const $followerOutput = document.querySelector(".followers .range-input__value .range-input__picker");

const $subscriptionPriceInput = document.querySelector("#subscriptionPrice");
const $subscriptionPriceOutput = document.querySelector(".subscription-price .range-input__picker");

const $totalOutput = document.querySelector(".earn__total output");

let followerValue = 0;
let subscriptionValue = 0;
let totalSum = 0;

const getPick = (element: HTMLInputElement): number => {
  return ((+element.value - +element.min) * 100) / (+element.max - +element.min);
};
const changePickerPosition = (output?: HTMLOutputElement) => (evt?: Event, element?: HTMLInputElement): void => {
  const target: HTMLInputElement = (evt?.target as HTMLInputElement) ?? element;
  const isSubscription = target.id === SUBSCRIPTION_RANGE_INPUT_ID;
  const leftShift = isSubscription ? SUBSCRIPTION_PICKER_SHIFT : FOLLOWER_PICKER_SHIFT;

  const percentPositionAtRange = getPick(target);
  output?.setAttribute(
    "style",
    `left: calc(${percentPositionAtRange}% + (${leftShift - percentPositionAtRange * THUMBNAIL_SHIFT}px))`
  );
  target.style.setProperty(CSS_INPUT_VARIABLE, `${percentPositionAtRange}%`);

  isSubscription ? (subscriptionValue = +target.value) : (followerValue = +target.value);
  const symbol = isSubscription ? "$" : "";
  output && (output.textContent = `${symbol}${target.value}`);

  totalSum = subscriptionValue * followerValue;
  $totalOutput && ($totalOutput.textContent = totalSum.toLocaleString("eu"));
};

changePickerPosition($followerOutput as HTMLOutputElement)(undefined, $followerInput as HTMLInputElement);
changePickerPosition($subscriptionPriceOutput as HTMLOutputElement)(undefined, $subscriptionPriceInput as HTMLInputElement);

const rangeInputHandler = (output?: HTMLOutputElement) => {
  return changePickerPosition(output);
};

$followerInput?.addEventListener("input", rangeInputHandler($followerOutput as HTMLOutputElement));
$subscriptionPriceInput?.addEventListener("input", rangeInputHandler($subscriptionPriceOutput as HTMLOutputElement));
